/* BNB header scripts                                                  assets/bnb-header-search.js
   Search box (14 Oct 2026, panel added 27 Oct 2026)
   (The 27 Oct click-to-open menu code was removed the same day: menus open on hover again,
   using the theme's own behavior.)

   Works on the search box added in layout/theme.liquid (.bnb-hsearch).
   1. Empty box, on click: a panel with Popular searches, the shopper's Recent searches and
      Best sellers. Data comes from /search?view=bnb-panel (templates/search.bnb-panel.liquid),
      which reads the shop metafield bnb.search_panel and adds live prices, images and stars.
      Recent searches are kept in the shopper's own browser only (localStorage, last 5).
   2. Typing 2+ letters: live results from Shopify's predictive search feed
      (theme.routes.predictiveSearch + '.json').
   Enter or the search button goes to the full search page; arrow keys move through the links;
   Escape or a click outside closes the panel. All text is set with textContent.
   On the search results page the box shows the words searched (the page's own second box
   is hidden on desktop in bnb-header.css).
   Phones (3 Nov 2026): the same panel also opens from the phone search bar (.bnb-msearch__form).
   That bar clips anything inside it, so on phones the panel sits on the page body instead, fixed
   just under the bar and filling the screen below it. Phone layout: Recent searches (last 3),
   Popular searches as tap chips, then Best sellers as a sideways row. Phone panel and search
   mode styles: section I of assets/bnb-header-2.css.
   Phone search mode (3 Nov 2026, Miles): while the panel is open the top strip and logo row hide
   and the search bar moves to the top of the screen with a Cancel button, and swiping the panel
   closes the keyboard so the whole list shows. */
(function () {
  'use strict';

  var RECENT_KEY = 'bnbRecentSearches';
  var PANEL_KEY = 'bnbSearchPanel';
  var PANEL_TTL = 20 * 60 * 1000;
  var panelData = null;
  var panelRequest = null;
  var boxCache = {};

  /* ---------- Recent searches (this browser only) ---------- */
  function getRecent() {
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (s) { return typeof s === 'string' && s; }) : [];
    } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim().slice(0, 80);
    if (q.length < 2) return;
    var list = getRecent().filter(function (s) { return s.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
  }
  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
  }

  /* ---------- Panel data (cached for 20 minutes per browser tab) ---------- */
  function loadPanel() {
    if (panelData) return Promise.resolve(panelData);
    try {
      var cached = JSON.parse(sessionStorage.getItem(PANEL_KEY) || 'null');
      if (cached && cached.t && Date.now() - cached.t < PANEL_TTL && cached.d) {
        panelData = cached.d;
        return Promise.resolve(panelData);
      }
    } catch (e) {}
    if (panelRequest) return panelRequest;
    panelRequest = fetch('/search?view=bnb-panel', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (text) {
        var d = JSON.parse(text);
        panelData = { terms: d.terms || [], products: d.products || [] };
        try { sessionStorage.setItem(PANEL_KEY, JSON.stringify({ t: Date.now(), d: panelData })); } catch (e) {}
        return panelData;
      })
      .catch(function () {
        panelRequest = null;
        return { terms: [], products: [] };
      });
    return panelRequest;
  }

  function init(form) {
    if (!form || form.dataset.bnbSuggest) return;
    form.dataset.bnbSuggest = '1';

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    /* Benefit wording in the empty box (Miles, 28 Oct 2026): tells shoppers how big the range is.
       "Thousands" counts flavors and sizes (2,474 options across 455 live products and 68 brands on
       28 Oct 2026, per Miles). The shorter wording fits the narrower box on smaller laptops; phones get
       "Search thousands of products" from the template in theme.liquid. */
    var wideBox = window.matchMedia('(min-width: 990px)');
    function setPlaceholder() {
      input.placeholder = wideBox.matches ? 'Search thousands of products from 65+ brands' : 'Search thousands of products';
    }
    setPlaceholder();
    if (wideBox.addEventListener) wideBox.addEventListener('change', setPlaceholder);

    try {
      var searched = new URLSearchParams(location.search).get('q');
      if (searched && /^\/search/.test(location.pathname)) {
        saveRecent(searched);
        if (!input.value) input.value = searched;
      }
    } catch (e) {}

    var phone = form.classList.contains('bnb-msearch__form');
    var panelId = phone ? 'BnbSearchSuggestPhone' : 'BnbSearchSuggest';
    var panel = document.createElement('div');
    panel.className = phone ? 'bnb-hsuggest bnb-hsuggest--m' : 'bnb-hsuggest';
    panel.id = panelId;
    panel.hidden = true;
    panel.bnbForm = form;
    if (phone) {
      document.body.appendChild(panel);
    } else {
      form.appendChild(panel);
    }

    /* Phones: keep the panel's top edge just under the search bar */
    function placePhone() {
      if (!phone) return;
      var bar = form.closest('.bnb-msearch') || form;
      var bottom = Math.round(bar.getBoundingClientRect().bottom);
      panel.style.setProperty('--bnb-msug-top', Math.max(bottom, 0) + 'px');
    }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panelId);
    input.setAttribute('aria-expanded', 'false');

    var base = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';
    var timer = null;
    var controller = null;
    var lastQuery = '';
    var activeIndex = -1;

    function money(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      return '$' + n.toFixed(2);
    }

    // BNB boxes only online (Nov 2026): snack and drink results show the site's display name
    // (e.g. "Quest Protein Bars (Box of 12)") and the box price, from templates/product.bnb-suggest.liquid
    // Each product is looked up once per page (boxCache), not again on every letter typed (3 Nov 2026).
    function boxPrice(p, span, fallback, titleEl) {
      var req = boxCache[p.handle];
      if (!req) {
        req = boxCache[p.handle] = fetch('/products/' + encodeURIComponent(p.handle) + '?view=bnb-suggest')
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .catch(function (err) { delete boxCache[p.handle]; throw err; });
      }
      req
        .then(function (d) {
          span.textContent = d.box ? cents(d.price) : fallback;
          if (titleEl && d.name) titleEl.textContent = d.name;
        })
        .catch(function () { span.textContent = fallback; });
    }

    function cents(value) {
      var n = parseInt(value, 10);
      if (isNaN(n)) return '';
      return '$' + (n / 100).toFixed(2);
    }

    function sized(url, width) {
      if (!url) return '';
      try {
        var u = new URL(url, location.origin);
        u.searchParams.set('width', String(width));
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function searchUrl(q) {
      var u = new URL(form.getAttribute('action') || '/search', location.origin);
      u.searchParams.set('q', q);
      return u.pathname + u.search;
    }

    function links() {
      return Array.prototype.slice.call(panel.querySelectorAll('a'));
    }

    function setActive(i) {
      var all = links();
      all.forEach(function (a) { a.classList.remove('is-active'); });
      activeIndex = i;
      if (i >= 0 && all[i]) {
        all[i].classList.add('is-active');
        all[i].scrollIntoView({ block: 'nearest' });
      }
    }

    /* Search mode holds the page still (iPhone Safari fix, 3 Nov 2026). Without this, a swipe on
       iPhone could scroll or bounce the page behind the panel: the page showed through above the
       list and the header classes flipped back and forth, so the screen blinked. The page is pinned
       where it was and put back on close, so the shopper keeps their place. The search bar itself is
       pinned to the top of the screen while this is on (section I of bnb-header-2.css). */
    var lockedAt = null;
    function lockPage() {
      if (lockedAt !== null) return;
      lockedAt = window.scrollY || window.pageYOffset || 0;
      var b = document.body.style;
      b.position = 'fixed';
      b.top = -lockedAt + 'px';
      b.left = '0';
      b.right = '0';
      b.width = '100%';
    }
    function unlockPage() {
      if (lockedAt === null) return;
      var y = lockedAt;
      lockedAt = null;
      var b = document.body.style;
      b.position = b.top = b.left = b.right = b.width = '';
      window.scrollTo(0, y);
    }

    function open() {
      if (!panel.childNodes.length) return;
      // search mode on first, so the bar has moved to the top before the panel is placed under it
      if (phone && !document.documentElement.classList.contains('bnb-msug-open')) {
        document.documentElement.classList.add('bnb-msug-open');
        lockPage();
      }
      placePhone();
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      /* only touch the class when it is there: removing an absent class still counts as a change
         for the class watcher below, which would loop */
      if (phone && document.documentElement.classList.contains('bnb-msug-open')) {
        document.documentElement.classList.remove('bnb-msug-open');
        unlockPage();
      }
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    }

    function thumb(url, cls, width) {
      var img = el('img', cls);
      img.src = sized(url, width);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    }

    var clockSvg = 'M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z';
    function icon(path) {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('class', 'bnb-hp__icon');
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', path);
      p.setAttribute('fill', 'none');
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '2');
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p);
      return svg;
    }

    /* ---------- 1. Panel for the empty box ---------- */
    function renderHome(data) {
      if (input.value.trim().length >= 2) return;
      panel.textContent = '';
      activeIndex = -1;
      panel.classList.add('bnb-hsuggest--home');

      var recent = getRecent();
      var wrap = el('div', 'bnb-hp');
      var side = el('div', 'bnb-hp__side');

      if (data.terms.length) {
        side.appendChild(el('p', 'bnb-hsuggest__head', 'Popular searches'));
        var terms = el('ul', 'bnb-hp__list');
        data.terms.forEach(function (t) {
          var li = el('li');
          var a = el('a', 'bnb-hp__term');
          a.href = t.url || searchUrl(t.q);
          if (t.img) a.appendChild(thumb(t.img, 'bnb-hp__term-img', 96));
          a.appendChild(el('span', '', t.q));
          li.appendChild(a);
          terms.appendChild(li);
        });
        side.appendChild(terms);
      }

      if (recent.length) {
        var head = el('div', 'bnb-hp__recent-head');
        head.appendChild(el('p', 'bnb-hsuggest__head', 'Recent searches'));
        var clear = el('button', 'bnb-hp__clear', 'Clear');
        clear.type = 'button';
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          clearRecent();
          renderHome(data);
          input.focus();
        });
        head.appendChild(clear);
        side.appendChild(head);
        var rl = el('ul', 'bnb-hp__list');
        recent.forEach(function (q) {
          var li = el('li');
          var a = el('a', 'bnb-hp__recent');
          a.href = searchUrl(q);
          a.appendChild(icon(clockSvg));
          a.appendChild(el('span', '', q));
          li.appendChild(a);
          rl.appendChild(li);
        });
        side.appendChild(rl);
      }

      if (side.childNodes.length) wrap.appendChild(side);

      if (data.products.length) {
        var main = el('div', 'bnb-hp__main');
        main.appendChild(el('p', 'bnb-hsuggest__head', 'Best sellers'));
        var grid = el('div', 'bnb-hp__grid');
        data.products.forEach(function (p) {
          var a = el('a', 'bnb-hp__card');
          a.href = p.url;
          var onSale = p.compare && parseInt(p.compare, 10) > parseInt(p.price, 10);
          if (onSale) a.appendChild(el('span', 'bnb-hp__tag', 'Sale'));
          if (p.img) a.appendChild(thumb(p.img, 'bnb-hp__img', 360));
          var rating = parseFloat(p.rating);
          if (rating > 0) {
            var stars = el('span', 'bnb-hp__stars');
            stars.appendChild(el('span', 'bnb-hp__star', '★'));
            stars.appendChild(document.createTextNode(' ' + rating.toFixed(1) + (p.reviews ? ' (' + p.reviews + ')' : '')));
            a.appendChild(stars);
          }
          a.appendChild(el('span', 'bnb-hp__title', p.title));
          if (p.vendor) a.appendChild(el('span', 'bnb-hp__vendor', p.vendor));
          var price = el('span', 'bnb-hp__price');
          if (onSale) price.appendChild(el('s', 'bnb-hp__was', cents(p.compare)));
          price.appendChild(document.createTextNode((p.from ? 'From ' : '') + cents(p.price)));
          a.appendChild(price);
          grid.appendChild(a);
        });
        main.appendChild(grid);
        wrap.appendChild(main);
      } else {
        wrap.classList.add('bnb-hp--narrow');
      }

      if (!wrap.childNodes.length) { close(); return; }
      panel.appendChild(wrap);
      open();
    }

    function showHome() {
      lastQuery = '';
      if (controller) controller.abort();
      loadPanel().then(function (data) {
        if (document.activeElement === input || form.contains(document.activeElement) || panel.contains(document.activeElement)) renderHome(data);
      });
    }

    /* ---------- 2. Live results while typing ---------- */
    function render(q, products, collections) {
      panel.textContent = '';
      activeIndex = -1;
      panel.classList.remove('bnb-hsuggest--home');

      if (!products.length && !collections.length) {
        panel.appendChild(el('p', 'bnb-hsuggest__empty', 'No products found for “' + q + '”. Press Enter to search everything.'));
      }

      if (collections.length) {
        panel.appendChild(el('p', 'bnb-hsuggest__head', 'Categories and brands'));
        var chips = el('div', 'bnb-hsuggest__chips');
        collections.slice(0, 4).forEach(function (c) {
          var a = el('a', 'bnb-hsuggest__chip', c.title);
          a.href = (c.url || '').split('?')[0];
          chips.appendChild(a);
        });
        panel.appendChild(chips);
      }

      if (products.length) {
        panel.appendChild(el('p', 'bnb-hsuggest__head', 'Products'));
        var list = el('ul', 'bnb-hsuggest__list');
        list.setAttribute('role', 'listbox');
        products.slice(0, 6).forEach(function (p) {
          var li = el('li');
          li.setAttribute('role', 'option');
          var a = el('a', 'bnb-hsuggest__item');
          a.href = (p.url || '').split('?')[0];
          var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (imgUrl) {
            var img = thumb(imgUrl, 'bnb-hsuggest__img', 96);
            img.width = 44;
            img.height = 44;
            a.appendChild(img);
          }
          var txt = el('span', 'bnb-hsuggest__txt');
          var titleEl = el('span', 'bnb-hsuggest__title', p.title || '');
          txt.appendChild(titleEl);
          var meta = [p.vendor, p.available === false ? 'Sold out' : ''].filter(Boolean).join(' · ');
          if (meta) txt.appendChild(el('span', 'bnb-hsuggest__meta', meta));
          a.appendChild(txt);
          var price = money(p.price);
          // BNB boxes only online (Nov 2026): snacks and drinks sold as boxes show the box price
          if ((p.type === 'Snacks' || p.type === 'Drinks') && p.handle && p.price_min !== p.price_max) {
            var boxSpan = el('span', 'bnb-hsuggest__price', '');
            a.appendChild(boxSpan);
            boxPrice(p, boxSpan, price, titleEl);
          } else if (price) a.appendChild(el('span', 'bnb-hsuggest__price', price));
          li.appendChild(a);
          list.appendChild(li);
        });
        panel.appendChild(list);
      }

      var all = el('a', 'bnb-hsuggest__all', 'See all results for “' + q + '”');
      all.href = searchUrl(q);
      panel.appendChild(all);
      open();
    }

    function run() {
      var q = input.value.trim();
      if (q.length < 2) { showHome(); return; }
      if (q === lastQuery && panel.childNodes.length && !panel.classList.contains('bnb-hsuggest--home')) { open(); return; }
      lastQuery = q;
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      var url = new URL(base + '.json', location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');

      fetch(url.toString(), { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          var res = (data && data.resources && data.resources.results) || {};
          render(q, res.products || [], res.collections || []);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          panel.textContent = '';
          close();
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) run(); else showHome();
    });

    /* Start loading the panel as soon as the pointer comes near the box, so it opens instantly. */
    form.addEventListener('pointerenter', function () { loadPanel(); }, { once: true });

    input.addEventListener('keydown', function (e) {
      var all = links();
      if (e.key === 'ArrowDown') {
        if (panel.hidden) { run(); return; }
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, all.length - 1));
      } else if (e.key === 'ArrowUp') {
        if (panel.hidden) return;
        e.preventDefault();
        setActive(Math.max(activeIndex - 1, -1));
      } else if (e.key === 'Enter') {
        if (!panel.hidden && activeIndex >= 0 && all[activeIndex]) {
          e.preventDefault();
          window.location.href = all[activeIndex].href;
        }
      } else if (e.key === 'Escape') {
        close();
      }
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
      saveRecent(input.value);
    });

    /* Where the press started decides "click outside". On phones, opening search mode moves the
       search bar to the top between the press and the click, so the click itself can land on the
       page behind and would close the panel the moment it opened (3 Nov 2026). */
    var pressedInside = false;
    document.addEventListener('pointerdown', function (e) {
      pressedInside = !!(e.target && e.target.isConnected && (form.contains(e.target) || panel.contains(e.target)));
    }, true);

    document.addEventListener('click', function (e) {
      if (pressedInside) { pressedInside = false; return; }
      if (!e.target.isConnected || form.contains(e.target) || panel.contains(e.target)) return;
      /* the phone product page Search button opens the bar and focuses the box: keep the panel */
      if (e.target.closest && e.target.closest('.bnb-msearch-btn')) return;
      close();
    });

    if (phone) {
      /* Cancel button beside the search bar (shows only in search mode). On product pages it also
         closes the slide-down bar, the same as tapping the Search button again. */
      var barWrap = form.closest('.bnb-msearch');
      if (barWrap && !barWrap.querySelector('.bnb-msearch__cancel')) {
        var cancel = el('button', 'bnb-msearch__cancel', 'Cancel');
        cancel.type = 'button';
        cancel.addEventListener('click', function () {
          close();
          if (document.activeElement === input) input.blur();
          var pdpBtn = document.querySelector('.bnb-msearch-btn');
          if (pdpBtn && document.documentElement.classList.contains('bnb-msearch-open')) pdpBtn.click();
        });
        barWrap.appendChild(cancel);
      }

      /* Swiping the panel closes the keyboard, so the whole list shows (common phone pattern).
         Tapping the box again brings the keyboard back. */
      // up-and-down swipes only: a sideways swipe through Best sellers keeps the keyboard
      var touchX = null, touchY = null;
      panel.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (touchY === null || document.activeElement !== input) return;
        var dx = Math.abs(e.touches[0].clientX - touchX);
        var dy = Math.abs(e.touches[0].clientY - touchY);
        if (dy > 10 && dy > dx) input.blur();
      }, { passive: true });

      /* Phones have no mouse to warn that a tap is coming (desktop loads the panel on pointerenter),
         so load the panel data quietly once the page has settled; the first tap then opens instantly. */
      var preload = function () { if (window.matchMedia('(max-width: 767px)').matches) loadPanel(); };
      var idle = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 4000 });
        else setTimeout(preload, 1500);
      };
      if (document.readyState === 'complete') setTimeout(idle, 2500);
      else window.addEventListener('load', function () { setTimeout(idle, 2500); }, { once: true });

      /* Close the phone panel when the product page search button closes the bar. If the bar
         slides up or down (page scroll, keyboard opening), move the panel so it stays right
         under the bar instead of closing it. */
      new MutationObserver(function () {
        if (panel.hidden) return;
        var root = document.documentElement;
        if (root.classList.contains('bnb-pdp-msearch') && !root.classList.contains('bnb-msearch-open')) { close(); return; }
        placePhone(); setTimeout(placePhone, 360);
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', function () { if (!panel.hidden) placePhone(); });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (!panel.hidden) placePhone(); });
    }
  }

  function start() {
    document.querySelectorAll('.bnb-hsearch, .bnb-msearch__form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Desktop menus: open only on a deliberate hover (Miles, 27 Oct 2026).
   The theme (main.js, MainNavigation) opens a menu the instant the mouse touches Categories,
   Goals, Brands or App, so menus popped open whenever the mouse passed over or the page
   scrolled under it. Here the theme's open signal is held back until the mouse has rested on
   the word for DELAY ms, and never fires while the page is scrolling. If a menu is already
   open, moving to the next word switches straight away. Closing is left to the theme. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 768px)');
  var TOP_ITEM = '.navigation__tier-1 > .navigation__item--with-children';
  var OPEN = 'navigation__item--show-children';
  var DELAY = 350;
  var timer = null, target = null, lastScroll = 0;

  function inNav(node) {
    return ['main-nav', 'proxy-nav'].some(function (id) {
      var n = document.getElementById(id);
      return n && n.contains(node);
    });
  }
  function anyOpen() {
    return !!document.querySelector('#main-nav .' + OPEN + ', #proxy-nav .' + OPEN);
  }
  function isTopItem(t) {
    return t && t.nodeType === 1 && t.matches(TOP_ITEM) && inNav(t);
  }

  window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });

  function fire(item) {
    timer = null;
    if (target !== item) return;
    if (Date.now() - lastScroll < 250) { timer = setTimeout(function () { fire(item); }, 250); return; }
    item.dispatchEvent(new Event('mouseenter'));
  }

  window.addEventListener('mouseenter', function (e) {
    if (!desktop.matches || !e.isTrusted || !isTopItem(e.target)) return;
    if (anyOpen()) return;
    e.stopImmediatePropagation();
    var item = e.target;
    target = item;
    clearTimeout(timer);
    timer = setTimeout(function () { fire(item); }, DELAY);
  }, true);

  window.addEventListener('mouseleave', function (e) {
    if (!e.isTrusted || e.target !== target) return;
    clearTimeout(timer);
    timer = null;
    target = null;
  }, true);
})();

/* Phone product pages: search icon next to the menu button (Miles, 29 Oct 2026).
   GA4 (Aug to Oct 2026, phones): only about 1.4% of product page views led to a search, so on
   product pages the full-width search bar starts closed and a magnifying glass sits beside the
   menu button. Tapping the icon slides the same search bar down with the keyboard open; tapping
   again, pressing Escape or scrolling down closes it. Every other page keeps the open bar.
   Styles: section G of assets/bnb-header-2.css. */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;
  var root = document.documentElement;
  root.classList.add('bnb-pdp-msearch');

  function setup() {
    var toggle = document.querySelector('.section-header .mobile-nav-toggle');
    var bar = document.querySelector('.bnb-msearch');
    if (!toggle || !bar || document.querySelector('.bnb-msearch-btn')) return;
    var input = bar.querySelector('input[name="q"]');
    var icon = bar.querySelector('button svg');
    bar.id = bar.id || 'BnbMobileSearchBar';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bnb-msearch-btn';
    btn.setAttribute('aria-label', 'Search');
    btn.setAttribute('aria-controls', bar.id);
    btn.setAttribute('aria-expanded', 'false');
    if (icon) btn.appendChild(icon.cloneNode(true));
    toggle.insertAdjacentElement('afterend', btn);

    var openedAt = 0;
    function isOpen() { return root.classList.contains('bnb-msearch-open'); }
    function open() {
      root.classList.add('bnb-msearch-open');
      root.classList.remove('bnb-msearch-hide');
      btn.setAttribute('aria-expanded', 'true');
      openedAt = window.scrollY || 0;
      /* focus inside the tap so phones open the keyboard */
      if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
    }
    function close() {
      root.classList.remove('bnb-msearch-open');
      btn.setAttribute('aria-expanded', 'false');
      if (input && document.activeElement === input) input.blur();
    }
    btn.addEventListener('click', function () { if (isOpen()) close(); else open(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    window.addEventListener('scroll', function () {
      if (!isOpen() || document.activeElement === input) return;
      if ((window.scrollY || 0) > openedAt + 60) close();
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
